<template>
  <div class="partner">
    <Heat @change="showForm"/>
    <Why />
    <Support />
    <!-- <Advantage /> -->
    <Come @change="showForm"/>
    <partnerForm :dialogVisbility.sync="dialogVisbility" />
    <HomeFooter />
  </div>
</template>

<script>
import HomeFooter from "../home/components/footer";
import Heat from "./components/heat";
import Why from "./components/why";
import Support from "./components/support";
import Advantage from "./components/advantage";
import Come from "./components/comeOn";
import partnerForm from "./components/partnerForm";
export default {
  name: "partner",
  components: {
    Heat,
    HomeFooter,
    Why,
    Support,
    Advantage,
    partnerForm,
    Come
  },
  data() {
    return{
      dialogVisbility:false
    }
  },
  methods:{
    showForm() {
      this.dialogVisbility = true;
    }
  }
};
</script>

<style lang="scss">
.partner {
  .page-wit {
    width: 1000px;
    margin: 0 auto;
  }
}
</style>
